import { PaymentsService } from '@festina/moneyin-general-types/moneyin/services/PaymentsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method = PaymentsService.paymentsServicePostMarkUnrelated
type MethodParam = Parameters<typeof method>[0]

export const useSubmitMarkUnrelated = ({ tenantId }: { tenantId: string }) =>
  useFestinaMutation({
    component: 'moneyIn',
    roles: PaymentsService.paymentsServicePostMarkUnrelated_roles,
    isScenario: false,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({ xTenantId: tenantId, ...arg }),
  })
